<template>
  <div>
    <b-form-group :label="label">
      <div
        :class="{'desabilitar-inputs': disabled}"
        style="display: inline;"
      >
        <file-upload
          ref="upload"
          v-model="value"
          :input-id="idUpload"
          class="btn btn-primary btn-sm mr-50"
          :multiple="false"
          @input="selecionado"
          @input-filter="inputFilter"
        >
          <i class="fas fa-plus" />
          Carregar
        </file-upload>
      </div>
      <b-btn
        :disabled="!textArquivo"
        variant="none"
        size="sm"
        class="btn-outline-primary btn-none mr-50"
        @click="visualizarArquivo"
      >
        <feather-icon icon="ExternalLinkIcon" />
      </b-btn>
      <b-btn
        :disabled="(disabled) || (!fileName && !textArquivo) || (desabilitarLixeira)"
        variant="none"
        size="sm"
        class="btn-outline-danger btn-none"
        @click="removeArquivo()"
      >
        <feather-icon icon="TrashIcon" />
      </b-btn>
    </b-form-group>
    <strong v-if="value[0] || textArquivo">Arquivo: {{ textArquivo ? textArquivo : value[0].name }}</strong>

    <visualizar-arquivo
      v-if="mostrarVisualizacao"
      :url="url"
      @hidden="fecharVisualizarArquivo()"
    />
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  name: 'UploadSocio',
  components: {
    FileUpload,
    FeatherIcon,
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    idUpload: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    visualizar: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    desabilitarLixeira: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileName: '',
      value: [],
      url: '',
      mostrarVisualizacao: false,
      valueAttr: '',
    }
  },
  computed: {
    textArquivo: {
      get() {
        return this.valueAttr ? this.valueAttr : this.text
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
  },
  watch: {
    text(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      const file = newFile
      if (file) {
        if (this.isDangerFile(file.name)) {
          this.$erro('Arquivo não permitido')
          return prevent()
        }
      }
      return null
    },
    visualizarArquivo() {
      this.visualizar()
        .then(payload => {
          if (payload.data) {
            this.url = payload.data
            this.mostrarVisualizacao = true
          }
        })
    },
    selecionado() {
      if (this.value[0]) {
        this.textArquivo = ''
        this.fileName = this.value[0].name
        this.$emit('selecionado', this.fileName)
      } else {
        this.fileName = ''
      }
    },
    removeArquivo() {
      if (this.value[0]) {
        this.$refs.upload.remove(this.value[0])
      }
      this.fileName = ''
      this.urlArquivo = ''
      this.text = ''
      this.$emit('removido')
    },
    fecharVisualizarArquivo() {
      this.mostrarVisualizacao = false
    },
    isDangerFile(fileName) {
      if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(fileName)) {
        return true
      }
      // Filter php html js file
      if (/\.(php5?|html?|jsx?)$/i.test(fileName)) {
        return true
      }

      return false
    },
  },
}
</script>
